import * as React from "react";

import { cn } from "@/lib/utils";

interface InputProps extends React.ComponentProps<"input"> {
  multiline?: boolean;
}

interface TextareaProps extends React.ComponentProps<"textarea"> {
  multiline: true;
}

type CombinedProps = InputProps | TextareaProps;

const Input = React.forwardRef<
  HTMLInputElement | HTMLTextAreaElement,
  CombinedProps
>(({ className, type, multiline, ...props }, ref) => {
  const baseClasses =
    "flex w-full rounded border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm";

  if (multiline) {
    return (
      <textarea
        className={cn(baseClasses, "min-h-[80px] resize-y", className)}
        ref={ref as React.ForwardedRef<HTMLTextAreaElement>}
        {...(props as React.ComponentProps<"textarea">)}
      />
    );
  }

  return (
    <input
      type={type}
      className={cn(baseClasses, "h-10", className)}
      ref={ref as React.ForwardedRef<HTMLInputElement>}
      {...(props as React.ComponentProps<"input">)}
    />
  );
});
Input.displayName = "Input";

export { Input };
